<router-outlet></router-outlet>
<ngx-ui-loader [text]="loaderText" [fgsTemplate]="foregroundSpinner"></ngx-ui-loader>
<ng-template #foregroundSpinner>
  <img class="loaderimg" src="assets/GIF BALLOON.gif"/>
</ng-template>
